export default {"src":"/_next/static/media/instagram.fe571dc5.svg","height":243,"width":243,"blurWidth":0,"blurHeight":0};